import { EnvironmentProviders, Provider } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { InitializeEffects } from './+state/initialize.effects';
import { INITIALIZE_FEATURE_KEY, initializeReducer } from './+state/initialize.reducer';
import { RouterStoreService } from './router-store.service';

/**
 * @used-by @scheduler-frontend/data-access-approaches
 * @used-by @scheduler-frontend/data-access-candidates
 * @used-by @scheduler-frontend/data-access-candidates-by-ranking
 * @used-by @scheduler-frontend/data-access-candidates-by-slots
 * @used-by @scheduler-frontend/data-access-location-schedules
 * @used-by @scheduler-frontend/data-access-scheduling
 * @used-by @scheduler-frontend/data-access-search
 * @used-by @scheduler-frontend/data-access-search-location-statistics
 * @used-by @scheduler-frontend/data-access-slots-by-candidate
 * @used-by @scheduler-frontend/data-access-weekly-schedules
 */
export function provideInitializeStore(): Provider | EnvironmentProviders[] {
  return [
    provideState({ name: INITIALIZE_FEATURE_KEY, reducer: initializeReducer }),
    provideEffects(InitializeEffects),
    RouterStoreService,
  ];
}
